import { ellipsis } from 'polished';
import { css } from '@emotion/react';

export const ellipsis_style = (width: string | number | undefined) => css`
  position: relative;
  line-height: 1.25;
  ${ellipsis(width)}
`;
